// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    personnel_find_employee: 'Buscando en la plantilla',
    personnel_employee_file: 'Leyendo el expediente',
    personnel_expiring_documents: 'Mirando lo que caduca',
    personnel_compliance_summary: 'Contando la plantilla',
    personnel_who_can_work: 'Mirando quién puede trabajar',
  },
  ca: {
    personnel_find_employee: 'Cercant a la plantilla',
    personnel_employee_file: 'Llegint l’expedient',
    personnel_expiring_documents: 'Mirant el que caduca',
    personnel_compliance_summary: 'Comptant la plantilla',
    personnel_who_can_work: 'Mirant qui pot treballar',
  },
  en: {
    personnel_find_employee: 'Looking through the staff',
    personnel_employee_file: 'Reading the file',
    personnel_expiring_documents: 'Checking what runs out',
    personnel_compliance_summary: 'Counting the staff',
    personnel_who_can_work: 'Working out who is eligible',
  },
  fr: {
    personnel_find_employee: 'Recherche dans le personnel',
    personnel_employee_file: 'Lecture du dossier',
    personnel_expiring_documents: 'Ce qui arrive à échéance',
    personnel_compliance_summary: 'Bilan du personnel',
    personnel_who_can_work: 'Qui est habilité à travailler',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
